<aside
  class="fixed flex flex-col top-0 px-5 left-0 bg-white dark:bg-gray-900 dark:border-gray-800 text-gray-900 h-screen transition-all duration-300 ease-in-out z-50 border-r border-gray-200"
  [ngClass]="{'w-[290px]':(isExpanded$ | async) || (isMobileOpen$ | async) || (isHovered$ | async),
    'w-[90px]': !(
      (isExpanded$ | async) ||
      (isMobileOpen$ | async) ||
      (isHovered$ | async)
    ),
    'translate-x-0': isMobileOpen$ | async,
    '-translate-x-full': !(isMobileOpen$ | async),
    'xl:translate-x-0': true
  }">
  <div class="py-8 flex" [ngClass]="{
      'xl:justify-center': !((isExpanded$ | async) || (isHovered$ | async)),
      'justify-start': (isExpanded$ | async) || (isHovered$ | async)
    }">

    <a routerLink="/" class="flex items-center">
      @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
      <img class="h-12 w-auto max-w-full object-contain dark:hidden" src="images/logo-crm/partner-crm-full.png"
        alt="Partner CRM" width="419" height="113" />
      <img class="hidden h-12 w-auto max-w-full object-contain dark:block" src="images/logo-crm/partner-crm-full-white.png"
        alt="Partner CRM" width="419" height="113" />
      } @else {
      <img class="h-auto w-12 dark:hidden" src="images/logo-crm/logocrmic.png" alt="Partner CRM" width="328"
        height="184" />
      <img class="hidden h-auto w-12 dark:block" src="images/logo-crm/logocrmwithe.png" alt="Partner CRM" width="315"
        height="180" />
      }
    </a>
  </div>

  <div class="flex flex-col overflow-y-auto duration-300 ease-linear no-scrollbar">
    <nav class="mb-6">
      <div class="flex flex-col gap-2">
        @for (section of sections; track trackByPrefix($index, section)) {
        <div>
          @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
          <button
            type="button"
            (click)="toggleSection(section.prefix)"
            class="mb-1.5 w-full text-xs uppercase flex items-center justify-between leading-[20px] text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors cursor-pointer"
            [attr.aria-expanded]="!isSectionCollapsed(section.prefix)">
            <span>{{ section.title }}</span>
            <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="w-4 h-4 transition-transform duration-300 ease-out"
              [ngClass]="{ '-rotate-90': isSectionCollapsed(section.prefix) }">
              <path d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396" stroke="currentColor" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
          } @else {
          <h2 class="mb-1.5 text-xs uppercase flex xl:justify-center leading-[20px] text-gray-400">
            <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="size-6">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M5.99915 10.2451C6.96564 10.2451 7.74915 11.0286 7.74915 11.9951V12.0051C7.74915 12.9716 6.96564 13.7551 5.99915 13.7551C5.03265 13.7551 4.24915 12.9716 4.24915 12.0051V11.9951C4.24915 11.0286 5.03265 10.2451 5.99915 10.2451ZM17.9991 10.2451C18.9656 10.2451 19.7491 11.0286 19.7491 11.9951V12.0051C19.7491 12.9716 18.9656 13.7551 17.9991 13.7551C17.0326 13.7551 16.2491 12.9716 16.2491 12.0051V11.9951C16.2491 11.0286 17.0326 10.2451 17.9991 10.2451ZM13.7491 11.9951C13.7491 11.0286 12.9656 10.2451 11.9991 10.2451C11.0326 10.2451 10.2491 11.0286 10.2491 11.9951V12.0051C10.2491 12.9716 11.0326 13.7551 11.9991 13.7551C12.9656 13.7551 13.7491 12.9716 13.7491 12.0051V11.9951Z"
                fill="currentColor"></path>
            </svg>
          </h2>
          }
          <!-- Wrapper grid-template-rows: anima de 0fr→1fr para colapsar/expandir suave sin medir altura por JS -->
          <div class="grid transition-[grid-template-rows,opacity] duration-300 ease-out"
               [ngClass]="{
                 'grid-rows-[0fr] opacity-0 pointer-events-none':
                   isSectionCollapsed(section.prefix) && ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)),
                 'grid-rows-[1fr] opacity-100':
                   !isSectionCollapsed(section.prefix) || !((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async))
               }">
          <ul class="flex flex-col gap-1 overflow-hidden min-h-0">
            @for (nav of section.items; track trackByIndex($index); let i = $index) {
            <li>
              @if (nav.subItems) {
              <button (click)="toggleSubmenu(section.prefix, i)" class="menu-item group cursor-pointer"
                [class.menu-item-active]="openSubmenu === section.prefix + '-' + i"
                [class.menu-item-inactive]="openSubmenu !== section.prefix + '-' + i" [ngClass]="{
                    'xl:justify-center': !(
                      (isExpanded$ | async) || (isHovered$ | async)
                    ),
                    'xl:justify-start':
                      (isExpanded$ | async) || (isHovered$ | async)
                  }">
                <span class="menu-item-icon-size inline-flex items-center justify-center transition-transform duration-300 origin-center"
                  [ngClass]="{
                      'menu-item-icon-active': openSubmenu === section.prefix + '-' + i,
                      'menu-item-icon-inactive': openSubmenu !== section.prefix + '-' + i,
                      'rotate-90': section.rotateIcon && openSubmenu === section.prefix + '-' + i
                    }" [innerHTML]="nav.icon | safeHtml">
                </span>
                @if ((isExpanded$ | async) || (isHovered$ | async) ||
                (isMobileOpen$ | async)) {
                <span class="menu-item-text">
                  {{ nav.name }}
                </span>
                }
                @if (nav.new && ((isExpanded$ | async) || (isHovered$ |
                async) || (isMobileOpen$ | async))) {
                <span class="ml-auto absolute right-10 menu-dropdown-badge" [ngClass]="{
                      'menu-dropdown-badge-active': openSubmenu === section.prefix + '-' + i,
                      'menu-dropdown-badge-inactive': openSubmenu !== section.prefix + '-' + i
                    }">
                  new
                </span>
                }
                @if ((isExpanded$ | async) || (isHovered$ | async) ||
                (isMobileOpen$ | async)) {
                <svg [ngClass]="{
                      'rotate-180 text-brand-500': openSubmenu === section.prefix + '-' + i
                    }" width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                  class="ml-auto w-5 h-5 transition-transform duration-200">
                  <path d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                }
              </button>
              <div class="overflow-hidden transition-all duration-300" [id]="section.prefix + '-' + i" [style.display]="
                    (isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)
                      ? 'block'
                      : 'none'
                  " [ngStyle]="{
                    height:
                      openSubmenu === section.prefix + '-' + i
                        ? (subMenuHeights[section.prefix + '-' + i] || 0) + 'px'
                        : '0px'
                  }">
                <ul class="mt-2 space-y-1 ml-9">
                  @for (subItem of nav.subItems; track $index) {
                  <li>
                    @if (subItem.disabled) {
                    <span class="menu-dropdown-item menu-dropdown-item-inactive opacity-50 cursor-not-allowed select-none"
                          [attr.aria-disabled]="true" title="Próximamente">
                      {{ subItem.name }}
                      <span class="ml-auto text-[10px] uppercase tracking-wide text-gray-400 dark:text-gray-500">
                        Próximo
                      </span>
                    </span>
                    } @else {
                    <a [routerLink]="subItem.path" routerLinkActive="" (click)="onSubmenuClick()"
                      class="menu-dropdown-item" [ngClass]="{
                              'menu-dropdown-item-inactive': !isActive(subItem.path),
                              'menu-dropdown-item-active': isActive(subItem.path)
                            }">
                      {{ subItem.name }}
                      <span class="flex items-center gap-1 ml-auto">
                        @if (subItem.new) {
                        <span class="menu-dropdown-badge" [ngClass]="{
                              'menu-dropdown-badge-active': isActive(subItem.path),
                              'menu-dropdown-badge-inactive': !isActive(subItem.path)
                            }">
                          new
                        </span>
                        }
                        @if (subItem.pro) {
                        <span class="ml-auto menu-dropdown-badge-pro" [ngClass]="{
                              'menu-dropdown-badge-pro-active': isActive(subItem.path),
                              'menu-dropdown-badge-pro-inactive': !isActive(subItem.path)
                            }">
                          pro
                        </span>
                        }
                      </span>
                    </a>
                    }
                  </li>
                  }
                </ul>
              </div>
              } @else {
              @if (nav.disabled) {
              <span class="menu-item menu-item-inactive opacity-50 cursor-not-allowed select-none"
                    [attr.aria-disabled]="true" title="Próximamente">
                <span class="menu-item-icon-size menu-item-icon-inactive" [innerHTML]="nav.icon | safeHtml"></span>
                @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
                <span class="menu-item-text">{{ nav.name }}</span>
                <span class="ml-auto text-[10px] uppercase tracking-wide text-gray-400 dark:text-gray-500">
                  Próximo
                </span>
                }
              </span>
              } @else if (nav.path) {
              <a [routerLink]="nav.path" routerLinkActive="menu-item-active" class="menu-item group"
                [ngClass]="{ 'menu-item-inactive': !isActive(nav.path) }">
                <span class="menu-item-icon-size" [ngClass]="{
                      'menu-item-icon-active': isActive(nav.path),
                      'menu-item-icon-inactive': !isActive(nav.path)
                    }" [innerHTML]="nav.icon | safeHtml">
                </span>
                <span class="menu-item-text">
                  @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
                  {{ nav.name }}
                  }
                </span>
              </a>
              }
              }
            </li>
            }
          </ul>
          </div>
        </div>
        }
      </div>
    </nav>
    @if (((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) && hasAdvancedTools) {
    <!-- Toggle "Modo avanzado": muestra/oculta herramientas técnicas de Automatización -->
    <div class="mb-4 px-1">
      <button
        type="button"
        (click)="toggleAdvancedMode()"
        [attr.aria-pressed]="advancedMode"
        title="Muestra herramientas técnicas: colas, probadores y webhooks."
        class="w-full flex items-center gap-3 rounded-lg px-3 py-2.5 border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/60 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors cursor-pointer">
        <svg class="w-4 h-4 shrink-0 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        <span class="flex-1 text-left">
          <span class="block text-xs font-medium text-gray-700 dark:text-gray-200">Modo avanzado</span>
          <span class="block text-[10px] text-gray-400 dark:text-gray-500 leading-tight">Colas, probadores y webhooks</span>
        </span>
        <!-- Switch -->
        <span class="relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors"
          [ngClass]="advancedMode ? 'bg-brand-500' : 'bg-gray-300 dark:bg-gray-600'">
          <span class="inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform"
            [ngClass]="advancedMode ? 'translate-x-4' : 'translate-x-0.5'"></span>
        </span>
      </button>
    </div>
    }

    @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
    <app-sidebar-widget />
    }
  </div>
</aside>
